module.exports = __webpack_public_path__ + "static/media/4ODA1.4949cf6b.jpg";